export const volumes = [
  {
    title: 'Volumen 1 — Mapa y Clasificación de la Historia Médica™',
    border: 'border-blue-400/30',
    items: [
      'Identificás y clasificás toda la documentación que tenés',
      'Creás una estructura clara para encontrar lo que necesitás',
      'Separás originales, copias y documentos dudosos',
      'Armás un índice que funciona como brújula del archivo',
      'Tenés una visión clara de lo registrado y de lo que queda pendiente de ubicar'
    ]
  },
  {
    title: 'Volumen 2 — Línea de Tiempo y Evolución Documentada™',
    border: 'border-green-400/30',
    items: [
      'Reconstruís cronológicamente la historia documentada sin depender de la memoria',
      'Vinculás cada acontecimiento con el papel que lo respalda',
      'Identificás períodos sin documentación para aclarar con profesionales',
      'Creás una secuencia clara y fácil de consultar cuando necesitás revisarla'
    ]
  },
  {
    title: 'Volumen 3 — Síntesis y Archivo Maestro™',
    border: 'border-amber-400/30',
    items: [
      'Convertís años de documentación en una referencia maestra clara',
      'Tenés un resumen actualizable que usás sin volver a empezar',
      'Creás un sistema de mantenimiento para que nunca vuelva al caos',
      'Sabés exactamente dónde está cada documento importante',
      'Podés incorporar nueva información sin perder el orden previo'
    ]
  }
] as const;

export const includedExtras = [
  'Hoja de ruta de 7 días lista para arrancar hoy',
  'Índice maestro imprimible para tu archivo',
  'Guía de clasificación de documentos médicos',
  'Sistema de mantenimiento para cada documento nuevo'
];

export const bonuses = [
  {
    number: '01',
    title: 'Kit Arranque en 30 Minutos™',
    value: '$12.000',
    details: [
      'Guía express para reunir documentación física y digital',
      'Un punto de partida claro para salir de la parálisis hoy',
      'Qué juntar primero y qué dejar para después'
    ]
  },
  {
    number: '02',
    title: 'Etiquetas y Separadores Médicos Listos para Imprimir™',
    value: '$10.000',
    details: [
      'Separadores imprimibles y etiquetas de categoría',
      'Código de colores para identificar todo de un vistazo',
      'Convertí una carpeta común en un archivo organizado'
    ]
  },
  {
    number: '03',
    title: 'Radar de Documentos Faltantes™',
    value: '$11.000',
    details: [
      'Matriz para detectar qué tenés, qué falta y qué es dudoso',
      'Dejás de depender de la memoria',
      'Sabés qué pedir y a quién en la próxima consulta'
    ]
  },
  {
    number: '04',
    title: 'Limpieza Digital de Archivos Médicos™',
    value: '$9.000',
    details: [
      'Sistema para rescatar archivos dispersos en el celular, la nube y el email',
      'Creás una carpeta digital central con respaldo',
      'Nomenclatura simple para encontrar todo en segundos'
    ]
  },
  {
    number: '05',
    title: 'Hoja de Ruta 7 Días Historia Médica en Orden™',
    value: '$10.000',
    details: [
      'Calendario de ejecución diaria, día por día',
      'Sabés exactamente qué hacer sin pensar de cero',
      'Versiones mínimas para los días con poco tiempo'
    ]
  }
] as const;
